import { useState, useEffect } from 'react';
import {
    fetchExcludedEmails,
    fetchEmailSignatures
} from '../api/suggestionService';

export const useSignatures = (userEmail) => {
    const [excludedEmails, setExcludedEmails] = useState([]);
    const [emailSignatures, setEmailSignatures] = useState([]);
    const [userEmailSignatures, setUserEmailSignatures] = useState([]);
    const [isLoadingSignatures, setIsLoadingSignatures] = useState(false);
    const [showSignatureSelect, setShowSignatureSelect] = useState(false);

    useEffect(() => {
        async function fetchExcludedEmailsAndUserSignatures() {
            try {
                const excludedEmailsList = await fetchExcludedEmails();
                setExcludedEmails(excludedEmailsList || []);
                console.log('Excluded emails:', excludedEmailsList);

                if (userEmail && excludedEmailsList) {
                    const isUserEmailExcluded = excludedEmailsList.some(excludedEmail =>
                        excludedEmail.email && excludedEmail.email.toLowerCase() === userEmail.toLowerCase()
                    );

                    if (isUserEmailExcluded) {
                        setIsLoadingSignatures(true);
                        setShowSignatureSelect(true);
                        const userSignatures = await fetchEmailSignatures(userEmail);
                        setUserEmailSignatures(userSignatures || []);
                        setIsLoadingSignatures(false);
                        console.log('User signatures (excluded email):', userSignatures);

                        if (userSignatures && userSignatures.length > 1) {
                            setShowSignatureSelect(true);
                        } else {
                            setShowSignatureSelect(false);
                        }
                    } else {
                        setUserEmailSignatures([]);
                        console.log('User email not in excluded list, no signatures needed');
                    }
                }
            } catch (error) {
                console.error('Error fetching excluded emails or user signatures:', error);
                setIsLoadingSignatures(false);
            }
        }

        fetchExcludedEmailsAndUserSignatures();
    }, [userEmail]);

    return {
        excludedEmails, setExcludedEmails,
        emailSignatures, setEmailSignatures,
        userEmailSignatures, setUserEmailSignatures,
        isLoadingSignatures, setIsLoadingSignatures,
        showSignatureSelect, setShowSignatureSelect
    };
};
